module.exports = __webpack_public_path__ + "img/es_logo_general.2b9d53f0.png";